import type { ComponentProps } from 'react';
type ArrowLeftProps = ComponentProps<'svg'> & {
  pathStroke?: string; // Add this line to extend the props
};

const ArrowLeft = ({ pathStroke = '#55657D', ...props }: ArrowLeftProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width={40}
      height={40}
      fill="none"
      {...props}
    >
      <path
        stroke={pathStroke}
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M35.455 20.33H4.545"
      />
      <path
        stroke={pathStroke}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M15.785 31.57 4.545 20.33l11.24-11.24"
      />
    </svg>
  );
};

export default ArrowLeft;